export { default as TableMassiveLoads } from "./TableMassiveLoads"